<template>
  <div class="main">
    <h5 class="pay-amount">支付总额：{{amount}}</h5>
    <div class="pay">
      <div class="pay-cell"
           v-for="(way,index) in ways"
           :key="index">
        <h5>{{way.name}}</h5>
        <img v-if="way.img_url" :src="baseURL + 'storage/' + way.img_url"
             alt="">
        <!-- <p>微信号</p> -->
        <p v-html="way.describe"></p>
      </div>
      <!-- <div class="pay-cell" v-if="ways.indexOf('1') > -1">
                <h5>微信支付</h5>
                <img :src="Weixin" alt="">
                <p>微信号</p>
                <p>26378383</p>
            </div>
            <div class="pay-cell" v-if="ways.indexOf('2') > -1">
                <h5>支付宝支付</h5>
                <img :src="Zhifubao" alt="">
                <p>支付宝账号</p>
                <p>26378383</p>
            </div>
            <div class="pay-cell" v-if="ways.indexOf('3') > -1">
                <h5>银联支付</h5>
                <img :src="Yinlian" alt="">
                <p>账户</p>
                <p>26378383 90039490087</p>
            </div> -->
    </div>
  </div>
</template>
<script>
import Weixin from '@/assets/images/files/weixin.png';
import Zhifubao from '@/assets/images/files/zhifubao.png';
import Yinlian from '@/assets/images/files/yinlian.png';
import * as apis from '@/api/mail'
import { baseURL } from '@/api/axios'
export default {
  data () {
    return {
      baseURL,
      amount: 0,
      Weixin,
      Zhifubao,
      Yinlian,
      ways: []
    }
  },
  mounted () {
    let id = this.$route.params.id;
    this.getPayMessage(id);
    this.getPayType(id);
  },
  methods: {
    async getPayMessage (id) {
      try {
        let data = {
          id: id
        };
        let res = await apis.getPayMail(data);
        if (res.code == 200) {
          // this.ways = res.data.pay_type.split(',');
          this.amount = res.data.amount;
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getPayType (id) {
      try {
        let data = {
          id
        };
        let res = await apis.getPayType(data);
        if (res.code == 200) {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].describe = res.data[i].describe.replace(/\n/g, "<br/>")
          }
          console.log(res.data)
          this.ways = res.data;

        }
      } catch (e) {
        console.log(e)
      }
    },
    setDoctorName (name) {
      console.log(name)
      if (name) {
        conosle.log()
        return name.replace(/\n/g, "<br/>");
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="less" scoped>
.pay {
  display: flex;
  width: 660px;
  align-items: center;
  justify-content: space-around;
  flex-direction: row;
  flex-wrap: wrap;
  // margin: 30px 0 100px;
  margin: 10px auto;
  .pay-cell {
    width: 310px;
    min-height: 398px;
    background: #fff;
    text-align: center;
    color: #3a3a3a;
    padding-top: 30px;
    margin-bottom: 20px;
    h5 {
      font-size: 24px;
      margin-bottom: 20px;
    }
    img {
      margin-bottom: 50px;
    }
    p {
      font-size: 22px;
      line-height: 24px;
      margin-bottom: 26px;
      // font-size: 18px;
    }
    &:last-child {
      width: 640px;
      p {
        padding: 0 10px;
        line-height: 32px;
      }
    }
  }
}

.pay-amount {
  font-size: 30px;
  line-height: 50px;
  text-align: center;
}
</style>